<template>
  <div>
    <table class="table table-hover table-bills-list">
      <thead class="thead-light">
      <tr>
        <template v-for="(header, index) in headers">
          <th
              v-if="(header.text ==  $gettext('Status') && !openOnly) || header.text !== $gettext('Status')"
              :key="index" :class="[{'table-sort': header.sort}, isActive(header.sort), isDesc(header.sort)]"
              @click="header.number ? sortNumber(header.sort) : sortString(header.sort)
          ">
            {{ header.text }}
          </th>
        </template>
      </tr>
      </thead>
      <tbody>
      <tr v-for="bill in sortBill"
          :key="bill.id"
          @click="$emit('billClicked', bill)"
          :class="{selected: selected(bill)}"
      >
        <td v-if="bill.billNumberWorkday">{{ bill.billNumberWorkday }}</td>
        <td v-else>{{ bill.number }} </td>
        <td>{{ $dayjs(bill.updatedDate).format('DD/MM/YYYY - HH:mm') }}</td>
        <td class="text-center">{{ bill.table }}</td>
        <td class="text-center">{{ bill.room }}</td>
        <td class="text-center">{{ printProperty(bill.staff, 'staffs', 'ref') }}</td>
        <td v-if="!openOnly">{{ getBillStatus(bill.status) }}</td>
        <td>{{ bill.status === VOIDED_STATUS ? 0 : bill.amount | currency }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BillService from '@/services/BillService';

export default {
  name: 'BillsTable',
  props: ['bills', 'openOnly', 'firstBill', 'secondBill'],
  data() {
    return {
      sort: {},
      filterBy: {
        table: '',
        room: '',
        staff: '',
        status: '',
      },
      headers: [
        {
          sort: 'number',
          text: this.$gettext('No'),
          number: true,
        },
        {
          sort: 'updatedDate',
          text: this.$gettext('Order time'),
        },
        {
          text: this.$gettext('Table'),
          sort: 'table',
        },
        {
          text: this.$gettext('Room'),
          sort: 'room',
        },
        {
          text: this.$gettext('Staff ID'),
          sort: 'staff',
        },
        {
          text: this.$gettext('Status'),
          sort: 'status',
        },
        {
          sort: 'amount',
          text: `${this.$gettext('Total')}(${this.getMap('currency').symbol})`,
          number: true,
        },

      ],
      sortBill: [],
    };
  },
  mounted() {
    if (this.bills) {
      this.sortBill = this.bills;
    }
  },
  watch: {
    bills(val) {
      this.sortBill = val;
    },
    
  },
  methods: {
    isDesc(field) {
      return this.sort && this.sort.field === field && this.sort.orderBy === 'desc' ? ' desc' : ' asc';
    },
    isActive(field) {
      return this.sort && this.sort.field === field ? ' active' : ' ';
    },
    setSort(field) {
      if (this.sort.field === field) {
        this.sort.orderBy = (this.sort.orderBy === 'desc' ? 'asc' : 'desc');
      } else {
        this.sort = {
          field,
          orderBy: 'desc',
        };
      }
    },
    sortString(field) {
      this.setSort(field);
      if (field === 'staff') {
        this.sortBill.sort((a, b) => {
          const aValue = this.printProperty(a.staff, 'staffs', 'ref').toUpperCase()
          const bValue = this.printProperty(b.staff, 'staffs', 'ref').toUpperCase()
          return this.sort.orderBy === 'asc'
                  ? aValue.localeCompare(bValue)
                  : bValue.localeCompare(aValue)
        });
      } else {
        this.sortBill.sort((a, b) => {
          if (this.sort.orderBy === 'asc') {
            const aValue = (a[this.sort.field] || "zzzzzzzzzzzzzzzzz")
                            .toString().toUpperCase()
            const bValue = (b[this.sort.field] || "zzzzzzzzzzzzzzzzz")
                            .toString().toUpperCase()
            return aValue.localeCompare(bValue)
          } else {
            const aValue = (a[this.sort.field] || "00000000000000000")
                            .toString().toUpperCase()
            const bValue = (b[this.sort.field] || "00000000000000000")
                            .toString().toUpperCase()
            return bValue.localeCompare(aValue)
          }
        });
      }
    },
    sortNumber(field) {
      this.setSort(field);
      if (field === 'amount') {
        this.sortBill.sort((a, b) => {
          if (a.status === this.VOIDED_STATUS) {
            a[this.sort.field] = 0;
          }
          if (b.status === this.VOIDED_STATUS) {
            b[this.sort.field] = 0;
          }
          if (this.sort.orderBy === 'asc') {
            return b[this.sort.field] - a[this.sort.field];
          }
          return a[this.sort.field] - b[this.sort.field];
        });
      } else {
        this.sortBill.sort((a, b) => {
          const aValue = parseInt(a[this.sort.field])
          const bValue = parseInt(b[this.sort.field]) 
          this.sort.orderBy === 'asc' ? (bValue - aValue) : (aValue - bValue)
          return this.sort.orderBy === 'asc' ? (aValue - bValue) : (bValue - aValue)
        });
      }
    },
    selected(currentBill) {
      if ((this.firstBill && currentBill.id === this.firstBill.id)
          || (this.secondBill && currentBill.id === this.secondBill.id)) {
        return true;
      }
      return false;
    },
    getBillStatus: BillService.getBillStatus,
  },
};
</script>
<style lang="css">
  .table-sort:after {
    content: "";
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #d6d6d6;
    margin-left: 8px;
    margin-top: -1px;
    transform: rotate(180deg);
    transition: 0.2s ease;
  }
  .table-sort.desc:after {
    transform: rotate(0deg);
  }
  .table-sort.active:after {
    border-bottom: 5px solid #000;
  }
  .select-custom {
    padding: 5px;
    margin: 5px;
  }
</style>
